const LOCALE = 'es-AR';

//Formatea un número con separador de miles y sin decimales
export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  const number = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(number)) return String(value);
  return new Intl.NumberFormat(LOCALE, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(number);
}

//Formatea un precio anteponiendo la moneda (código o símbolo)
export function formatPrice(value, currency) {
  const formatted = formatNumber(value);
  if (!formatted) return '';
  return currency ? `${currency} ${formatted}` : formatted;
}
